export default __webpack_public_path__ + "static/media/michcron-march22.9c58cfb2.webp";